<template>
  <b-card class="segment-card">
    <b-row>
      <b-col cols>Segment {{segment.segment_id}}</b-col>
      <b-col class="segment-edit" cols="4">
        <div class="pull-right">
          <a v-on:click="$emit('copy', segment)">
            <i class="fa fa-copy"></i>
          </a>
          <a v-on:click="$emit('edit', segment)">
            <i class="fa fa-edit"></i>
          </a>
          <a v-if="!isReadonly" v-on:click="$emit('remove', segment)">
            <i class="fa fa-minus-circle"></i>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b v-if="segment.use_when_patient_pay_not_set">Used when patient pay is not set</b>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span
          v-if="offerType==='patient_pay' && (segment.out_of_pocket_minimum_amt || segment.out_of_pocket_minimum_amt === 0)"
        >
          Patient Pay greater than
          {{segment.out_of_pocket_minimum_amt | currency}}
        </span>
        <span
          v-if="segment.out_of_pocket_maximum_amt"
        >and less than {{segment.out_of_pocket_maximum_amt | currency}}</span>
        <span
          v-if="offerType==='days_supply' && (segment.days_supply_minimum_amt || segment.days_supply_minimum_amt === 0)"
        >
          Days Supply greater than or equal to
          {{segment.days_supply_minimum_amt}}
        </span>
        <span
          v-if="segment.days_supply_maximum_amt"
        >and less than or equal to {{segment.days_supply_maximum_amt}}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">Short Text:</b-col>
      <b-col>{{segment.offer_short_text}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="3">Long Text:</b-col>
      <b-col>{{segment.offer_long_text}}</b-col>
    </b-row>
  </b-card>
</template>
<script>
  export default {
    name: "VOfferSegmentListItem",
    props: {
      segment: {
        required: true,
        type: Object
      },
      offerType: {
        required: true,
        type: String
      },
      isReadonly: {
        required: true,
        type: Boolean
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VOfferSegmentListItem.vue